const digest = 'a1e8308207a0acbcd9ee087b0468853e9c09b2dbb95351262b63459b22c92d7f';
const css = `._card_10swm_1 {
  margin-top: 24px;
 a {
  text-decoration: underline;
  };
};

._listStyle_10swm_8 {
  position: relative;
  width: 95%;
};

@media (max-width: 800) {
  ._listStyle_10swm_8 {
    width: 100%;
  }
}

._accordionDescription_10swm_19{
  min-height: 100px;
}`;
(function() {
  if ( global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'card': '_card_10swm_1', 'listStyle': '_listStyle_10swm_8', 'accordionDescription': '_accordionDescription_10swm_19' };
export const card = '_card_10swm_1';
export const listStyle = '_listStyle_10swm_8';
export const accordionDescription = '_accordionDescription_10swm_19';
export { css, digest };